import * as fieldTypes from '../../../../../../constants/FieldTypes';

/* merge */

export function splitOrMergeActiveField(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    if (field.merge) {
        splitField(field);
    } else {
        field.toggleMerge();
        field.setMergedField(field.nextField);
        // if we merge hidden field to visible, it also turns to visible
        if (!field.hidden && field.mergedField.hidden) {
            field.mergedField.setHide(false);
        }
        field.parentCollection.fields.splice(field.index + 1, 1);
    }
}

export function splitField(field) {
    field.toggleMerge();
    field.mergedField.merged = null;
    field.collection.parentCollection.fields.splice(field.index + 1, 0, field.mergedField);
    field.setMergedField(null);
}

export function disableMerge(field) {
    return (
        field.type === fieldTypes.TAB ||
        field.merged ||
        (!field.merge && (!field.nextField || field.nextField.merge))
    );
}

/* new area */

export function isNewAreaDisabled(field) {
    return field.type === fieldTypes.TAB || field.hidden || field.merged;
}

export function hideOrShowNewArea(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    field.setNewArea(!field.newarea);
}
